import React, { FC, useEffect }                   from "react";
import { useDispatch }                            from "react-redux";
import { useHistory }                             from "react-router";
import { Button, Header, Icon, Message, Segment } from "semantic-ui-react";
import GetCancelRequestedReservationHistory
                                                  from "../../../../application/usecase/reservation/history/GetCancelRequestedReservationHistory";
import MenuType                                   from "../../../../domain/menu/MenuType";
import { useReservationHistories }                from "../../../../infrastructure/redux/reservation/history";
import LeftPositionSection                        from "../../../components/common/layout/LeftPositionSection";
import RightPositionSection                       from "../../../components/common/layout/RightPositionSection";
import OfficeSelector                             from "../../../components/common/OfficeSelector";
import BaseLayout                                 from "../../../components/layout/BaseLayout";
import ReservationHistoryCards
                                                  from "../../../components/reservation/history/ReservationHistoryCards";

const ReservationCancelRequestedPage: FC = () => {
  const histories = useReservationHistories();
  const history = useHistory();
  const getCancelRequestedReservationHistory = new GetCancelRequestedReservationHistory(useDispatch());

  useEffect(() => getCancelRequestedReservationHistory.execute(), []);

  return (
    <>
      <BaseLayout
        menuType={ MenuType.RESERVATION }
        headerTitle="予約キャンセル依頼"
      >
        <LeftPositionSection>
          <section style={ {width: "100%"} }>
            <Button
              icon
              labelPosition="left"
              onClick={ () => history.push("/reservation") }
            >
              <Icon name="arrow left"/>
              予約管理へ戻る
            </Button>
          </section>

          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </LeftPositionSection>
        {
          histories.isEmpty()
            ?
            <>
              <Segment
                placeholder
              >
                <Header textAlign="center">
                  予約キャンセル依頼はありません。
                </Header>
              </Segment>
            </>
            :
            <>
              <Message warning>
                <Message.Header>
                  以下の予約キャンセル依頼が届いています。
                </Message.Header>
                <p>
                  必要に応じて連絡を行い、予約キャンセルを確定してください。<br/>
                  予約キャンセルを確定すると、予約者に自動で通知されます。
                </p>
              </Message>
            </>
        }
        <ReservationHistoryCards histories={ histories }/>
      </BaseLayout>
    </>
  );
}

export default ReservationCancelRequestedPage;
